import Twitter from 'images/socials/twitter_1.png';
import Facebook from 'images/socials/facebook_1.png';
import Email from 'images/socials/email_1.png';
import Vimeo from 'images/socials/vimeo_1.png';
import YouTube from 'images/socials/youtube_1.png';

function importAll(r) {
  return r.keys().map(r);
}

export const organizationLogos = importAll(require.context('../images/orgs', false, /\.(png|jpe?g|svg)$/));

export const staticData = {
  titles: {
    timestamp: "Timestamp",
    organization: "Organization",
    organizational: "Organizational sector",
    affiliated: "Does your organization work with the City or County of Los Angeles?",
    initiatives: "Programs/Initiatives (If applicable)",
    creative: "Creative Sector Alignment",
    pipeline: "Pipeline Service",
    overview: "Organizational/Program Overview",
    ages: "Ages Served",
    populations: "Particular Populations Served",
    individuals: "Number of Individuals Served",
    community: "Neighborhood/Community Served",
    contact: "To Connect/Contact",
    information: "For more information",
    interviewed: "Did organization participate in an interview?"
  },
  "pipeline-content": {
    EXPOSURE: "introduce students to career opportunities in the creative industries",
    REENGAGEMENT: "reconnect young people to their education and their future through the creative arts",
    "WORKFORCE READINESS": "teach soft skills required for success in the creative industries",
    PLACEMENT: "connect young people to workforce opportunities in the creative industries",
    SCHOLARSHIPS: "provide scholarships to young people in programs related to the creative industries",
    STIPENDS: "provide stipends to support students' engagement in internships or other learning environments",
    INSTRUCTION: "increase students' interest, abilities and skills in the creative arts",
    CERTIFICATION: "provide certificate or degree indicating readiness for workforce opportunities in creative industries",
    INTERNSHIPS: "provide internship to young people in the creative industries",
    "STUDENT SUPPORTS": "provide student supports such as food, transportation, supplies, clothing, health services, etc"
  },
  organizational: [
    "creative industry",
    "higher education",
    "k-12/alt education",
    "non-profit",
    "workforce investment",
  ],
  pipeline: [
    "EXPOSURE",
    "RE-ENGAGEMENT",
    "WORKFORCE READINESS",
    "PLACEMENT",
    "SCHOLARSHIPS",
    "STIPENDS",
    "INSTRUCTION",
    "CERTIFICATION",
    "INTERNSHIPS",
    "STUDENT SUPPORTS"
  ],
  creative: [
    "architecture/interior design",
    "arts galleries",
    "communication arts",
    "digital media",
    "entertainment",
    "fashion",
    "fine and performing arts school",
    "furniture/decorative arts",
    "industrial design services",
    "publishing and printing",
    "toys",
    "visual and performing arts providers"
  ],
  ages: [
    "0-4",
    "5-10",
    "11-13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19-24",
    "24+",
    "All ages/no age restrictions"
  ],
  populations: [
    "Females",
    "Males",
    "Foster Youth",
    "Low-income students",
    "Incarcerated youth",
    "Disconnected youth (not employed or in school)",
    "Students enrolled in a postsecondary institution",
    "Probation Youth",
    "No restrictions/all populations served"
  ],
  individuals: [
    "Less than 10",
    "11-50",
    "51-100",
    "101-500",
    "501-1000",
    "More than 1000"
  ],
  affiliated: [
    "city",
    "county"
  ],
  community: [
    "Burbank",
    "Central Los Angeles (Hollywood, Mid-City, Mid-Wilshire, Downtown, Koreatown, Pico-Union)",
    "Compton",
    "Culver City",
    "Eastside (Boyle Heights, East Los Angeles, Lincoln Heights)",
    "Glendale",
    "Long Beach",
    "Northeast Los Angeles (Highland Park, Eagle Rock, Glassel Park)",
    "Pasadena",
    "San Fernando Valley (Canoga Park, Northridge, Reseda, Pacoima, Van Nuys)",
    "San Gabriel Valley (Monterrey Park, Alhambra, Whittier, Hacienda Heights)",
    "South Bay (Westchester, Inglewood, Playa Del Rey)",
    "South Los Angeles (Watts, Jefferson Park, Hyde Park, Historic South-Central, Baldwin Hills/Crenshaw)",
    "Southeast Los Angeles (Montebello, Huntington Park, Pico Rivera, Norwalk)",
    "Westside (Mar Vista, Venice, Westwood, Palms, Brentwood)",
    "City of Los Angeles",
    "County of Los Angeles"
  ]
}

export const students = {
  blanca: {
    name: 'Blanca',
    // title: 'Native Content',
    title: {
      placement:'Native Content', 
      site: 'http://nativecontent.com/'
    },
    details: `With support from Mayor Eric Garcetti's <a target="_blank" href="https://www.lamayor.org/mayor-garcetti-launches-evolve-entertainment-fund-boost-diversity-entertainment-industry" rel="noopener noreferrer">Evolve Entertainment Fund</a>, Blanca received an 8-week internship with production company Native Content. She worked alongside Native Content Executive Producer and artworxLA Board member Ned Brown, learning the logistics of producing major advertising campaigns for print, online media, and television.`
  },
  john: {
    name: 'John',
    // title: 'Film Independent',
    title: {
      placement:'Film Independent',
      site: 'https://www.filmindependent.org/'
    },
    details: `Supported by the <a target="_blank" href="https://www.lamayor.org/mayor-garcetti-launches-evolve-entertainment-fund-boost-diversity-entertainment-industry" rel="noopener noreferrer">Evolve Entertainment Fund</a>, John worked alongside the President and executives at Film Independent to support the production of the LA Film Festival, the Spirit Awards, and attended screenings at the Writers Guild Theatre.`
  },
  emely: {
    name: 'Emely',
    // title: 'Snap Inc.',
    title: {
      placement:'Snap Inc.',
      site: 'https://www.snap.com/en-US/'
    },
    details: "Emely (<em>far right in front</em>) joined a class of twenty at the Sanp Design Academy. This academy was a hands-on, paid, 100-hour technology and design program for LA-based community college students.\n Emely participated in custom creative workshops, fireside chats, and received mentorship from Snap employees. The internship was made possible with the support of Bixel Exchange."
  },
  alfredo: {
    name: 'Alfredo',
    // title: 'Angel City Lumber',
    title: {
      placement:'Angel City Lumber',
      site: 'https://www.angelcitylumber.com/'
    },
    details: "Fresh from his residency program at the Penland School of Crafts, Alfredo (<em>second to left</em>) completed an internship with Angel City Lumber, an urban lumber yard in Boyle Heights. ACL is a small business specializing in fabricating wood products from the fallen trees of Los Angeles and Alfredo assisted in stacking and labeling fresh cut lumber, creating an inventory of collected logs and maintaining the showroom and wood samples for customers. Alfredo's internship with Angel City Lumber was made possible with the support of the Boyle Heights Youth Source Center"
  },
}

export const pathwaysData = {
  "Providers & Organizations": {
    "Secondary Education": [
      "Continuation high schools",
      "Linked Learning Pathways",
      "School districts"
    ],
    "Nonprofit Organizations": [
      "Arts education organizations",
      "Leadership organizations",
      "College & career readiness organizations",
    ],
    "Workforce Investment": [
      "Chamber of Commerce",
      "Economic & Workforce Development Dept",
      "Mayor's Office",
      "Economic Development Corporation",
      "Workforce Investment Boards",
      "YouthSource Centers",
    ],
    "Post-secondary Institutions": [
      "Community colleges",
      "Arts colleges",
      "Trade tech colleges",
    ],
    "Creative Industries": [
      "Production companies",
      "Agencies",
      "Studios",
    ],
    "Supporting": [
      "Government funding agencies (Arts Commissions)",
      "Foundations",
    ],
  },
  "Services & Delivery": {
    "Secondary Education": [
      "Instruction",
      "Student Supports",
      "Exposure",
      "Re-engagement"
    ],
    "Nonprofit Organizations": [
      "Student Supports",
      "Instruction",
      "Exposure",
      "Re-engagement",
      "Workforce Readiness",
      "Placement",
      "Scholarships",
      "Stipends"
    ],
    "Workforce Investment": [
      "Internships",
      "Certification",
      "Placement",
      "Workforce Readiness",
      "Stipends",
      "Student Supports",
    ],
    "Post-secondary Institutions": [
      "Instruction",
      "Workforce Readiness",
      "Placement",
      "Certification",
      "Scholarships",
      "Student Supports",
    ],
    "Creative Industries": [
      "Internships",
      "Exposure",
    ],
    "Supporting": [
    ],
  },
  "Goals": {
    "Secondary Education": [
      "<strong>Preparing</strong> college & career readiness",
      "<strong>Improving</strong> social & decision-making",
      "<strong>Building</strong> self-motivation & persistence",
      "<strong>Guiding</strong> youth towards becoming contributing members of local and global community"
    ],
    "Nonprofit Organizations": [
      "<strong>Facilitating</strong> access & connections to resources",
      "<strong>Strengthening</strong> preparedness & readiness",
      "<strong>Engaging</strong> students in the arts",
    ],
    "Workforce Investment": [
      "<strong>Facilitating</strong> access & connection",
      "<strong>Building</strong> professional skills",
      "<strong>Expanding</strong> social networks",
      "<strong>Increasing</strong> the talent pool",
    ],
    "Post-secondary Institutions": [
      "<strong>Expanding</strong> networks",
      "<strong>Deepening</strong> students' interest in a range of topics",
      "<strong>Fostering</strong> career advancement & growth",
      "<strong>Teaching</strong> students how to understand and exercise choice",
      "<strong>Increasing</strong> students' options"
    ],
    "Creative Industries": [
      "<strong>Providing</strong> on the job experience",
      "<strong>Expanding</strong> networks",
      "<strong>Offering</strong> the first step to employment",
      "<strong>Diversifying</strong> the workforce",
      "<strong>Diversifying</strong> the stories told in the creative industries"
    ],
    "Supporting": [
    ],
  }
};

export const pathwaysGlossary = {
    "Certification": "Providing certificate or degree indicating readiness for workforce opportunities in creative industries",
    "Exposure": "Introducing students to career opportunities in the creative industries",
    "Instruction": "Increasing students' interest, knowledge, and transferable skills valued in creative industries",
    "Internships": "Providing paid entry-level work exposure opportunities to young people in the creative industries",
    "Placement": "Connecting young people to workforce opportunities in the creative industries",
    "Re-engagement": "Reconnecting young people to their education and their future through the creative arts",
    "Scholarships": "Providing funded opportunities to young people in programs related to the creative industries",
    "Stipends": "Providing pay to support students' engagement in internships or other learning environments",
    "Student Supports": "Providing student supports such as food, transportation, supplies, clothing, health services, etc",
    "Workforce Readiness": "Teaching soft skills such as time management, problem solving, communication, for success in the creative industries",
};

export const socialData = [
  { 
    title: 'facebook',
    image: Facebook,
    url: 'https://www.facebook.com/artworxLA/'
  },
  {
    title: 'twitter',
    image: Twitter,
    url: 'https://twitter.com/artworxLA'
  },
  {
    title: 'youtube',
    image: YouTube,
    url: 'https://www.youtube.com/user/artworxLA'
  },
  {
    title: 'vimeo',
    image: Vimeo,
    url: 'http://vimeo.com/theheartproject'
  },
  {
    title: 'email',
    image: Email,
    url: 'mailto:elevate@artworxLA.org'
  },
]



// WEBPACK FOOTER //
// ./src/constants/constants.js